import styled from "styled-components";
import {ReactComponent as pencil} from "./pencil.svg";

export const Pencil = styled(pencil)`
  margin: 0;
  path {
    fill: #ffffffb3
  }
`;